import { makeStyles } from '@material-ui/core/styles';
import Typography from 'components/CncUI/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    boxShadow: 'none',
    backgroundColor: '#f4fbfa',
    width: 295,
    height: 85,
    alignItems: 'center',
  },
  image: {
    margin: '3px 0 4px 38px',
    width: 78,
    height: 78,
  },
  small: {
    margin: '3px 0 4px 38px',
    width: 64,
    height: 63,
  },
  content: {
    textAlign: 'left',
    paddingBottom: '12px !important',
  },
  title: {
    fontSize: 18,
    fontWeight: 400,
    marginBottom: 0,
    lineHeight: '20px',
  },
  subTitle: {
    marginTop: 0,
  },
  text: {
    lineHeight: '16px',
  },
  extra: {
    fontSize: 10,
    lineHeight: '16px',
  },
  green: {
    color: `${palette.cncUI.alert.green.primary} !important`,
  },
}));

const PhoneEnrollmentCard = props => {
  const classes = useStyles();
  const {
    image = '',
    title = '',
    subTitle = '',
    variant,
    id,
    justAdded,
  } = props;
  return (
    <Card key={id} className={classes.root} id={id}>
      <CardMedia
        className={variant ? classes.small : classes.image}
        image={image}
      />
      <CardContent className={classes.content}>
        <Typography className={classes.title}>{title}</Typography>
        {subTitle && (
          <Typography className={classes.subTitle}>{subTitle}</Typography>
        )}
        {justAdded && (
          <Typography
            variant="body2"
            className={classes.green}
            id={`${id}Added`}
          >
            Added
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default PhoneEnrollmentCard;
